import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8081d0f2&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&id=8081d0f2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8081d0f2",
  null
  
)

export default component.exports